import { landmineNames } from '@mm/constants/landmine-names';
import { PageBillingType } from '@mm/state/interfaces/connected-page';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPagePlanInfoSelector } from '@mm/state/selectors/facebookPageSelector';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { compose } from 'recompose';
import { MAP_BUTTON, PRO_BUTTON_TYPES } from '../constants';
import './TypeButton.scss';

type OuterProps = {
  type: string;
  onClick: () => void;
  isSelected: boolean;
};
type InnerProps = ReturnType<typeof mapStateToProps>;
type Props = OuterProps & InnerProps;

const TypeButton = (props: Props) => {
  const { type, onClick, isSelected, freeOrSpecialPricePlan } = props;
  const buttonTitle = MAP_BUTTON[type];
  const className = classnames('type-button btn-outline-warning', {
    'type-button--selected': isSelected,
  });
  const modalActions = useModalActions();

  const handleClick = () => {
    if (
      (PRO_BUTTON_TYPES as string[]).includes(type) &&
      freeOrSpecialPricePlan
    ) {
      modalActions.openUniversalUpgradeLandmineModal({
        landmineName: landmineNames['WIDGETS__BUTTONS__TYPE-BUTTON'],
        planFallback: PageBillingType.Pro,
      });
    } else {
      onClick();
    }
  };

  return (
    <Button
      className={className}
      onClick={handleClick}
      disabled={isSelected}
      outline={!isSelected}
    >
      {buttonTitle}
    </Button>
  );
};

const mapStateToProps = state => ({
  freeOrSpecialPricePlan:
    activeFacebookPagePlanInfoSelector(state).info.isFreeOrSpecialPlan,
});

const enhance = compose<InnerProps, OuterProps>(connect(mapStateToProps, null));

const TypeButtonEnhanced = enhance(TypeButton);

export default TypeButtonEnhanced;
